import { createFileRoute } from '@tanstack/react-router'
import { EditTeamDialogPending } from '@/routes/_app/-components/shared/dialog-pending'
import { idParams, useModalSlot } from '@/components/custom/modal-slot'
import EditTeamDialog from '@/routes/_app/-dialogs/edit-team'

export const Route = createFileRoute('/@modal/teams/$teamId/edit')({
  params: idParams('teamId'),
  staticData: { slotScope: '/_app' },
  pendingComponent: EditTeamDialogPending,
  component: EditTeamSlot,
})

function EditTeamSlot() {
  const { params, ...slot } = useModalSlot(Route)
  return <EditTeamDialog teamId={Number(params.teamId)} {...slot} />
}
